export const activateHamburger =  () => {
    document.addEventListener("DOMContentLoaded",()=> {
        let menu = document.querySelector('.menu');
        menu.addEventListener("click",()=> {
            menu.classList.toggle('open');
            document.querySelector(".navbar-mobile").classList.toggle("navbar-mobile--active");
          })
    })

 }
 